import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TimeInput,
  Input,
  DatePicker,
  Textarea,
  Select,
  SelectItem,
} from "@nextui-org/react";
import "./ModelForm.css";

const CanteenForm = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  
    navigate("/admin/canteen");
  };

  return (
    <div className="main-inner-wrapper leavemenu-wrapper">
     
      <div className="px-4">
        <div className="leave-apply__wrapper p-4 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-gray-500 rounded-xl">
        <h1 className="incident-report-heading ">Add Canteen Details</h1>
          <div className="form-container mt-8">
            <form onSubmit={handleSubmit}>
              <div>
                <div className="form-row">
                  <Input
                    variant="bordered"
                    label="Canteen Number"
                  />
                  <Input
                    variant="bordered"
                    label="Canteen Name"
                  />
                </div>
                {/* <div className="form-row">
                  <DatePicker variant="bordered" label="Date" />
                  <TimeInput variant="bordered" label="Time" />
                </div> */}
                <div className="form-row">
                  <Select
                    label="Manager Name"
                    className="max-w-full"
                    variant="bordered"
                  >
                    <SelectItem key="one" value="one">
                      Siva kumar
                    </SelectItem>
                    <SelectItem key="two" value="two">
                      Devaraj
                    </SelectItem>
                    <SelectItem key="third" value="third">
                      Akash
                    </SelectItem>
                    <SelectItem key="four" value="four">
                      Dhanajayan
                    </SelectItem>
                  </Select>
                  <Input
                    variant="bordered"
                    label="Contact Number"
                    type="number"
                  />
                </div>

                <div className="flex justify-center items-center gap-4" >
                  <Button className="incidentSubmitBtn" type="submit">
                    Submit
                  </Button>
                  <Button color="danger" variant="flat" onClick={() => navigate('/admin/canteen')}>
                    Cancel
                  </Button>
                </div>

              </div>
               </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CanteenForm;
